import {
  Rate,
  Avatar,
  Layout,
  Tabs,
  Empty,
  Steps,
  Form,
  Button,
  Input,
  Spin,
  Modal,
} from "antd";
import { PageHeader } from "@ant-design/pro-layout";
import axios from "axios";
import PropTypes from "prop-types";
import React, {
  ReactElement,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import { responseNotification } from "../../../utils/notify";
import { useNavigate, useParams } from "react-router";
import {
  DmOrderTypeArray,
  getImgUrl,
  MerchantOrderTypeArray,
  ReturnOrderTypeArray,
} from "../../../utils";
import { EditOutlined, PhoneOutlined } from "@ant-design/icons";
import cn from "classnames";
import moment from "moment";
import OrderExtra from "./extra";
import MapBox from "../../common/MapBox";
import { useSelector } from "react-redux";
import { isAllowedService } from "../../../utils/services";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSortAmountDownAlt } from "@fortawesome/free-solid-svg-icons";

const { Content } = Layout;
const { TabPane } = Tabs;
const { Step } = Steps;
const { TextArea } = Input;

const SingleOrder = ({ refetch }: any): ReactElement => {
  const { token } = useSelector((state) => (state as any)?.authReducer);
  const navigate = useNavigate();
  const route = useParams();
  const [loading, setLoading] = useState(false);
  const [edit, setEdit] = useState(false);
  const [form] = Form.useForm();
  const [statusModal, setStatusModal] = useState(false);
  const [productMap, setProductMap] = useState<any>({});
  const [selectedProducts, setSelectedProducts] = useState<any[]>([]);
  const [selectedProductBarcode, setSelectedProductBarcode] = useState<any>([]);
  const [indeterminate, setIndeterminate] = useState(true);
  const [checkAll, setCheckAll] = useState(false);
  const [checkedList, setCheckedList] = useState<any[]>([]);

  const [singleOrderInfo, setSingleOrderInfo] = useState<any>({
    loading: false,
    data: null,
  });

  // ✅ ACTION MODAL (OrderExtra)
  const [extraOpen, setExtraOpen] = useState(false);

  const orderIdFromRoute = (route as any)?.orderId;
  {isAllowedService(`Orders Extra`) && (
    <Button
      type="dashed"
      onClick={() => setStatusModal(true)}
      disabled={
        singleOrderInfo?.status === "PICKED" ||
        singleOrderInfo?.status === "COMPLETED" ||
        singleOrderInfo?.status === "DELIVERED" ||
        singleOrderInfo?.status === "REVIEWED" ||
        singleOrderInfo?.status === "CANCELLED"
      }
      title="Change Status"
    >
      <FontAwesomeIcon icon={faSortAmountDownAlt} />
    </Button>
  )}
  const fetchOrderDetails = useCallback(
    (getOrderId: any) => {
      if (!getOrderId) return;

      try {
        setSingleOrderInfo({ loading: true, data: undefined });

        axios
          .get(
            `${process.env.REACT_APP_ORDER_API}/admin/return-order/details?id=${getOrderId}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          )
          .then((res) => {
            if (res.status === 200) {
              const returnOrder = res?.data?.returnOrder;

              setSingleOrderInfo({
                loading: false,
                data: returnOrder,
              });

              // keep your existing mapping logic
              const tempProductMap: any = {};
              returnOrder?.products?.forEach((p: any) => {
                if (p?.id) {
                  tempProductMap[p?.id] = {
                    productId: p?.id,
                    quantity: p?.quantity || 0,
                    returnReason: "",
                    variationId: p?.variation?.variationId,
                    images: "",
                    videos: "",
                  };
                }
              });
              setProductMap(tempProductMap);

              setCheckedList(
                returnOrder?.products?.map((p: any) => p?.id) || []
              );
              setSelectedProducts(returnOrder?.products || []);
            } else {
              setSingleOrderInfo({ loading: false, data: null });
              responseNotification(
                res.statusText || "something went wrong",
                "error"
              );
            }
          })
          .catch(() => {
            setSingleOrderInfo({ loading: false, data: null });
          });
      } catch {
        setSingleOrderInfo({ loading: false, data: null });
      }
    },
    [token]
  );
  const onStatusChange = async (statusValue) => {
    // if (status === "CANCELLED" && !note) {
    //   responseNotification("To cancel note is required!");
    // }
    if (!singleOrderInfo?.orderId) {
      responseNotification("Order Id is required!");
    } else {
      setLoading(true);

      const readyData = {
        orderId: singleOrderInfo?.orderId,
        status: statusValue,
        // status: "ACCEPTED_BY_MERCHANT",
       // note: note,
      };

      await fetch(
        `${process.env.REACT_APP_ORDER_API}/order/by-merchant?orderId=${singleOrderInfo?.orderId}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(readyData),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          setLoading(false);

          if (res.statusCode === 200) {
            responseNotification("Status Updated Successfully", "success");
            form.resetFields();
            refetch();
            setStatusModal(false);
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          setLoading(false);
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };

  const editOrder = useCallback(
    (data: any) => {
      try {
        axios
          .put(
            `${process.env.REACT_APP_ORDER_API}/admin/order`,
            {
              orderId: orderIdFromRoute,
              shippingAddress: data?.shippingAddress,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          )
          .then((res) => {
            if (res.status === 200) {
              responseNotification(
                "Shipping Address updated successfully!",
                "success"
              );
              setEdit(false);
              fetchOrderDetails(orderIdFromRoute);
            } else {
              responseNotification(
                res.statusText || "something went wrong",
                "error"
              );
            }
          })
          .catch((err) => console.log(err));
      } catch (error) {
        console.log(error, "error");
      }
    },
    [fetchOrderDetails, orderIdFromRoute, token]
  );

  const onCheckAllChange = (e: any) => {
    setSelectedProductBarcode(e.target.checked ? checkedList : []);
    setIndeterminate(false);
    setCheckAll(e.target.checked);
  };

  const onChangeCheckbox = (val: any) => {
    setSelectedProductBarcode((prevVal: any) => {
      const newVal = val;
      let newArr = Array.from(prevVal);
      const found = prevVal.find((item: any) => item === newVal);
      if (!found) newArr.push(newVal);
      else newArr = newArr.filter((item) => item !== newVal);
      return newArr;
    });

    setIndeterminate(
      !!checkedList.length &&
        checkedList.length <= selectedProductBarcode.length
    );
    setCheckAll(checkedList.length === selectedProductBarcode.length);
  };

  useEffect(() => {
    fetchOrderDetails(orderIdFromRoute);
  }, [fetchOrderDetails, orderIdFromRoute]);

  const order = singleOrderInfo?.data;

  const bannerUrl = useMemo(
    () => getImgUrl(order?.shop?.banner),
    [order?.shop?.banner]
  );
  const shopLogoUrl = useMemo(
    () => getImgUrl(order?.shop?.logo),
    [order?.shop?.logo]
  );

  return (
    <React.Fragment>
      <main className="px-2 pt-4">
        <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
          {/* Header */}
          <div className="col-span-full">
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100">
              <PageHeader
                className="site-page-header px-4 py-3 mb-0"
                onBack={() => navigate(-1)}
                title={
                  <div className="flex items-center gap-3">
                    <h1 className="text-xl font-semibold text-gray-900">
                      Return Order Details
                    </h1>
                    {order?.status ? (
                      <span className="px-3 py-1 rounded-full text-xs font-semibold bg-blue-50 text-blue-700 border border-blue-100">
                        {order?.status?.split("_").join(" ")}
                      </span>
                    ) : null}
                  </div>
                }
                
                extra={[
                  <Button
                    type="default"
                    danger
                    title="Accept Order"
                    onClick={() => onStatusChange("ACCEPTED_BY_MERCHANT")}
                   
                  >
                    Accept Order
                  </Button>,
                ]}
              />
            </div>
            <Modal
              title="Order Actions"
              open={extraOpen}
              onCancel={() => setExtraOpen(false)}
              footer={null}
              destroyOnClose
              centered
              width={520}
              zIndex={2147483000}
            >
              <OrderExtra
                orderDetails={singleOrderInfo?.data}
                selectedProducts={selectedProducts}
                refetch={() =>
                  fetchOrderDetails(
                    singleOrderInfo?.data?.id || orderIdFromRoute
                  )
                }
              />
            </Modal>
          </div>

          {/* LEFT SIDEBAR */}
          <div className="xl:col-span-1 space-y-6">
            {/* Shop Card */}
            <div className="bg-white rounded-3xl shadow-md border border-gray-100 overflow-hidden">
              <div className="relative">
                <div className="h-36 w-full bg-gray-100 overflow-hidden">
                  {bannerUrl ? (
                    <img
                      src={bannerUrl}
                      alt="Shop Banner"
                      className="h-36 w-full object-cover"
                      loading="lazy"
                    />
                  ) : (
                    <div className="h-36 w-full bg-gradient-to-r from-gray-100 to-gray-200" />
                  )}
                </div>

                <div className="absolute left-6 -bottom-10">
                  <div className="bg-white rounded-full p-2 shadow-lg border border-gray-100">
                    <Avatar
                      src={shopLogoUrl}
                      size={80}
                      className="bg-gray-50"
                    />
                  </div>
                </div>
              </div>

              <div className="pt-14 pb-6 px-6">
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <h2 className="text-lg font-bold text-gray-900">
                      {order?.shop?.name
                        ? order?.shop?.name?.toUpperCase()
                        : "—"}
                    </h2>

                    <div className="mt-2 flex items-center text-sm text-gray-600 gap-2">
                      <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-gray-100">
                        <PhoneOutlined className="text-gray-600" />
                      </span>
                      <span className="font-medium">
                        {order?.shop?.contactNumber?.split("+88")?.join("") ||
                          "—"}
                      </span>
                    </div>

                    <div className="mt-3 flex items-center gap-3">
                      <Rate value={order?.shop?.rating || 0} disabled />
                      <span className="px-2 py-0.5 rounded-full text-xs font-semibold bg-blue-50 text-blue-700 border border-blue-100">
                        {order?.shop?.numberOfRating || 0}
                      </span>
                    </div>
                  </div>

                  <div className="text-right">
                    {order?.paymentStatus ? (
                      <div className="text-xs font-semibold text-gray-700">
                        Payment
                      </div>
                    ) : null}
                    {order?.paymentStatus ? (
                      <div
                        className={cn(
                          "mt-1 inline-flex items-center px-3 py-1 rounded-full text-xs font-bold border",
                          order?.paymentStatus === "PAID"
                            ? "bg-green-50 text-green-700 border-green-100"
                            : "bg-red-50 text-red-700 border-red-100"
                        )}
                      >
                        {order?.paymentStatus?.split("_").join(" ")}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>

            {/* Status Logs Card */}
            <div className="bg-white rounded-3xl shadow-md border border-gray-100 p-6">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-bold text-gray-900">Status Logs</h3>
                <span className="text-xs text-gray-500">
                  {order?.createdAt
                    ? moment(order?.createdAt).format("ll")
                    : ""}
                </span>
              </div>

              <div className="max-h-[420px] overflow-auto pr-2">
                <Steps
                  current={Object.values(ReturnOrderTypeArray).indexOf(
                    order?.status
                  )}
                  direction="vertical"
                  size="small"
                >
                  {Object.values(ReturnOrderTypeArray)?.map((type, i) => {
                    const found = order?.statusLogs?.find(
                      (log: any) =>
                        log?.value === (ReturnOrderTypeArray as any)[i]
                    );

                    return (
                      <Step
                        key={i}
                        title={
                          <span className="font-semibold">
                            {type?.split("_").join(" ")}
                          </span>
                        }
                        subTitle={
                          found?.datetime
                            ? moment(found?.datetime).format("lll")
                            : undefined
                        }
                        description={
                          found ? (
                            <div className="text-xs text-gray-600">
                              <div className="italic">
                                {found?.createdBy?.name}
                              </div>
                              <div className="mt-1">{found?.note}</div>
                            </div>
                          ) : undefined
                        }
                      />
                    );
                  })}
                </Steps>
              </div>
            </div>
          </div>

          {/* RIGHT CONTENT */}
          <div className="xl:col-span-2">
            <Layout className="bg-transparent">
              <Content className="main-content-layout">
                <div className="bg-white rounded-3xl shadow-md border border-gray-100 overflow-hidden">
                  {singleOrderInfo?.loading ? (
                    <div className="py-24 flex items-center justify-center">
                      <Spin size="large" />
                    </div>
                  ) : (
                    <div className="p-4 sm:p-6">
                      <Tabs tabPosition="top">
                        {/* DETAILS */}
                        <TabPane tab="ORDER DETAILS" key="Details">
                          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
                            <div>
                              <div className="text-xs font-semibold text-gray-500">
                                Base Order ID
                              </div>
                              <div className="mt-1 text-sm font-semibold text-gray-900">
                                {order?.baseOrderId || "—"}
                              </div>
                            </div>

                            <div>
                              <div className="text-xs font-semibold text-gray-500">
                                Order ID
                              </div>
                              <div className="mt-1 text-sm font-semibold text-gray-900">
                                {order?.orderId || "—"}
                              </div>
                            </div>

                            <div>
                              <div className="text-xs font-semibold text-gray-500">
                                Order Date
                              </div>
                              <div className="mt-1 text-sm font-semibold text-gray-900">
                                {order?.createdAt
                                  ? moment(order?.createdAt).format("lll")
                                  : "—"}
                              </div>
                            </div>

                            <div className="sm:col-span-1">
                              <div className="text-xs font-semibold text-gray-500">
                                Customer Info
                              </div>
                              <div className="mt-2 flex items-center gap-3">
                                <Avatar
                                  src={order?.customer?.profilePicture}
                                  size="large"
                                />
                                <div className="leading-tight">
                                  <div className="font-bold text-gray-900">
                                    {order?.customer?.name?.toUpperCase() ||
                                      "—"}
                                  </div>
                                  <div className="text-sm text-gray-600">
                                    {order?.customer?.mobileNumber
                                      ?.split("+88")
                                      ?.join("") || "—"}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="sm:col-span-1">
                              <div className="flex items-center justify-between">
                                <div className="text-xs font-semibold text-gray-500">
                                  Shipping Address
                                </div>
                                <Button
                                  type="dashed"
                                  shape="circle"
                                  size="small"
                                  className="!border-gray-200"
                                  onClick={() => setEdit(!edit)}
                                >
                                  <EditOutlined />
                                </Button>
                              </div>

                              <div className="mt-2 text-sm text-gray-700">
                                {edit ? (
                                  <Form
                                    form={form}
                                    layout="vertical"
                                    onFinish={editOrder}
                                    autoComplete="off"
                                  >
                                    <Form.Item
                                      name="shippingAddress"
                                      initialValue={order?.shippingAddress}
                                    >
                                      <TextArea
                                        rows={3}
                                        placeholder="Shipping Address"
                                      />
                                    </Form.Item>
                                    <Button
                                      type="primary"
                                      danger
                                      htmlType="submit"
                                    >
                                      Done
                                    </Button>
                                  </Form>
                                ) : (
                                  <div className="bg-gray-50 border border-gray-100 rounded-2xl p-3">
                                    {order?.shippingAddress || "—"}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="sm:col-span-1 grid grid-cols-2 gap-4">
                              <div>
                                <div className="text-xs font-semibold text-gray-500">
                                  Payment Method
                                </div>
                                <div className="mt-1 text-sm font-semibold text-gray-900">
                                  {order?.paymentMethod || "—"}
                                </div>
                              </div>

                              <div>
                                <div className="text-xs font-semibold text-gray-500">
                                  Total Paid
                                </div>
                                <div className="mt-1 text-sm font-semibold text-gray-900">
                                  ৳{order?.totalPaid ?? 0}
                                </div>
                              </div>

                              <div>
                                <div className="text-xs font-semibold text-gray-500">
                                  DUE
                                </div>
                                <div className="mt-1 text-sm font-semibold text-gray-900">
                                  ৳
                                  {(order?.total ?? 0) -
                                    (order?.totalPaid ?? 0)}
                                </div>
                              </div>

                              <div>
                                <div className="text-xs font-semibold text-gray-500">
                                  Payment Status
                                </div>
                                <div className="mt-1">
                                  {order?.paymentStatus ? (
                                    <span
                                      className={cn(
                                        "inline-flex px-3 py-1 rounded-full text-xs font-bold border",
                                        order?.paymentStatus === "PAID"
                                          ? "bg-green-50 text-green-700 border-green-100"
                                          : "bg-red-50 text-red-700 border-red-100"
                                      )}
                                    >
                                      {order?.paymentStatus
                                        ?.split("_")
                                        .join(" ")}
                                    </span>
                                  ) : (
                                    "—"
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Product header */}
                          <div className="mt-8 border border-gray-100 rounded-2xl overflow-hidden">
                            <div className="grid grid-cols-12 bg-gray-50 px-4 py-3 text-xs font-bold text-gray-700">
                              <div className="col-span-5">Product</div>
                              <div className="col-span-2">Variation</div>
                              <div className="col-span-1">TP</div>
                              <div className="col-span-2">Price</div>
                              <div className="col-span-1">Qty</div>
                              <div className="col-span-1 text-right">Total</div>
                            </div>

                            {selectedProducts?.length ? (
                              selectedProducts?.map((product: any, index) => {
                                const qty = product?.quantity ?? 0;
                                const tp = product?.variation?.price?.tp ?? 0;
                                const mrp = product?.variation?.price?.mrp ?? 0;
                                const discounted =
                                  product?.variation?.price?.discountedPrice;
                                const unitPrice = discounted ?? mrp;
                                const rowTotal = unitPrice * qty;

                                return (
                                  <div
                                    key={index}
                                    className="grid grid-cols-12 px-4 py-3 border-t border-gray-100 hover:bg-rose-50/40"
                                  >
                                    <div className="col-span-5 flex items-center gap-3">
                                      <Avatar
                                        shape="square"
                                        size={48}
                                        src={product?.productImage}
                                        className="bg-gray-50"
                                      />
                                      <div className="min-w-0">
                                        <div className="text-sm font-semibold text-gray-900 truncate">
                                          {product?.name || "—"}
                                        </div>
                                        {product?.baseOrderId ? (
                                          <div className="text-xs text-gray-500 truncate">
                                            {product?.baseOrderId}
                                          </div>
                                        ) : null}
                                      </div>
                                    </div>

                                    <div className="col-span-2 text-sm text-gray-700 flex items-center">
                                      {product?.variation?.variationName || "—"}
                                    </div>

                                    <div className="col-span-1 text-sm text-gray-700 flex items-center">
                                      ৳{tp}
                                    </div>

                                    <div className="col-span-2 text-sm text-gray-700 flex items-center gap-2">
                                      <span>৳{mrp}</span>
                                      {discounted && discounted !== mrp ? (
                                        <span className="text-xs font-bold text-rose-600">
                                          = ৳{discounted}
                                        </span>
                                      ) : null}
                                    </div>

                                    <div className="col-span-1 text-sm text-gray-700 flex items-center">
                                      x{qty}
                                    </div>

                                    <div className="col-span-1 text-sm font-semibold text-gray-900 flex items-center justify-end">
                                      ৳{rowTotal}
                                    </div>
                                  </div>
                                );
                              })
                            ) : (
                              <div className="p-6">
                                <Empty />
                              </div>
                            )}
                          </div>
                        </TabPane>

                        {/* SHOP INFO */}
                        <TabPane tab="SHOP INFO" key="ShopInfo">
                          <div className="max-w-2xl">
                            <div className="bg-white border border-gray-100 rounded-3xl shadow-sm overflow-hidden">
                              <div className="h-44 bg-gray-100 overflow-hidden">
                                {bannerUrl ? (
                                  <img
                                    className="h-44 w-full object-cover"
                                    src={bannerUrl}
                                    alt="Shop banner"
                                  />
                                ) : (
                                  <div className="h-44 w-full bg-gradient-to-r from-gray-100 to-gray-200" />
                                )}
                              </div>

                              <div className="px-6 pb-6">
                                <div className="flex items-end gap-4 -mt-10">
                                  <div className="bg-white rounded-full p-2 shadow-lg border border-gray-100">
                                    <Avatar
                                      src={shopLogoUrl}
                                      size={90}
                                      className="bg-gray-50"
                                    />
                                  </div>

                                  <div className="pb-2">
                                    <div className="text-xl font-extrabold text-gray-900">
                                      {order?.shop?.name?.toUpperCase() || "—"}
                                    </div>
                                    <div className="mt-1 text-sm text-gray-600">
                                      {order?.shop?.slug || ""}
                                    </div>
                                  </div>
                                </div>

                                <div className="mt-6 space-y-3 text-sm">
                                  {[
                                    ["Shop ID", order?.shop?.id],
                                    [
                                      "Contact Number",
                                      order?.shop?.contactNumber,
                                    ],
                                    ["Address", order?.shop?.address],
                                    ["Description", order?.shop?.description],
                                    ["Prepare Time", order?.shop?.prepareTime],
                                    [
                                      "Base Delivery Charge",
                                      order?.shop?.baseDeliveryCharge
                                        ? `৳${order?.shop?.baseDeliveryCharge}`
                                        : "",
                                    ],
                                    [
                                      "Delivery Condition",
                                      order?.shop?.isFreeDelivery
                                        ? "Free Delivery"
                                        : "Paid Delivery",
                                    ],
                                    ["Status", order?.shop?.status],
                                  ].map(([label, value]: any, i: number) => (
                                    <div
                                      key={i}
                                      className="flex justify-between gap-6"
                                    >
                                      <div className="font-semibold text-gray-700">
                                        {label}
                                      </div>
                                      <div className="text-gray-600 text-right break-words">
                                        {value || "—"}
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        </TabPane>

                        {/* DRIVER INFO */}
                        {order?.deliveryMan && (
                          <TabPane tab="DRIVER INFO" key="Driver">
                            <div className="bg-white border border-gray-100 rounded-3xl shadow-sm p-6 mb-6">
                              <div className="flex items-center gap-4">
                                <Avatar
                                  size={80}
                                  className="rounded-2xl shadow-md"
                                  src={order?.deliveryMan?.profilePicture}
                                  alt={order?.deliveryMan?.name}
                                />
                                <div>
                                  <h3 className="text-xl font-extrabold text-gray-900">
                                    {order?.deliveryMan?.name}
                                  </h3>
                                  <div className="text-sm text-gray-600 mt-1">
                                    {order?.deliveryMan?.mobileNumber
                                      ?.split("+88")
                                      ?.join("")}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="bg-white border border-gray-100 rounded-3xl shadow-sm overflow-hidden">
                              <MapBox
                                draggable={false}
                                coordinate={{
                                  lat: order?.deliveryManLocation?.latitude,
                                  lng: order?.deliveryManLocation?.longitude,
                                }}
                              />
                            </div>
                          </TabPane>
                        )}
                      </Tabs>
                    </div>
                  )}
                </div>
              </Content>
            </Layout>
          </div>
        </div>
      </main>
    </React.Fragment>
  );
};

SingleOrder.propTypes = {
  match: PropTypes.object,
  params: PropTypes.object,
  selectedProduct: PropTypes.string,
};

export default SingleOrder;
